import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { Extrapolate, interpolate, useAnimatedStyle, } from 'react-native-reanimated';
const CollapsableParallax = ({ scrollY, children, style, height, ...props }) => {
    const containerStyle = useAnimatedStyle(() => ({
        transform: [
            {
                translateY: interpolate(scrollY.value, [0, 40], [0, -50], Extrapolate.CLAMP),
            },
        ],
        opacity: interpolate(scrollY.value, [0, 40], [1, 0], Extrapolate.CLAMP),
    }), []);
    const spacerStyle = useAnimatedStyle(() => ({
        height: interpolate(scrollY.value, [0, 40], [height, 0], Extrapolate.CLAMP),
    }), [height]);
    return (<>
      <Animated.View style={[spacerStyle]}/>
      <Animated.View {...props} style={[containerStyle, style, styles.containerStyle]}>
        {children}
      </Animated.View>
    </>);
};
const styles = StyleSheet.create({
    containerStyle: {
        position: 'absolute',
    },
});
export default memo(CollapsableParallax);
